import { DecisionSource } from '@bpos/v1/over-ask';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { PlaceBetStatus } from '@frontend/sports/types/betslip';

import { IBetslipPickStorage } from '../../core/picks/pick-models';
import {
    IFailedSlipPickResult,
    IFailedSlipResult,
    IPlacedBetslipResult,
    ISucceededPartialSlipResult,
    ISucceededSlipPickResult,
    ISucceededSlipResult,
} from '../betplacement/models';
import { BetPlacementErrorSaved } from '../validation/errors/bet-placement-error';
import { ResultErrorSaved } from '../validation/errors/result/result-error';
import { IBetslipResultSummaryViewModel } from './models/betslip-result-summary.model';

export interface IBetslipResultState {
    result: IPlacedBetslipResult;
    keepPlacedBetsInBetslip: boolean;
    summary: Nullable<IBetslipResultSummaryViewModel>;
    decisionSource?: DecisionSource;
    isOfferModified: boolean;
    keepPlacedBetsInLinearSingle: boolean;
    keepPlacedBetsInLinearCombo: boolean;
    keepPlacedBetsInLinearSystem: Record<string, boolean>;
    keepPlacedBetsInLinearBetBuilder: Record<string, boolean>;
    keepPlacedBetsInLinearTeaser: boolean;
}

export const defaultResultState: IBetslipResultState = {
    result: {
        status: PlaceBetStatus.Failed,
        resultMessage: '',
        slips: [],
        teasedPoints: 0,
    },
    keepPlacedBetsInBetslip: false,
    summary: null,
    isOfferModified: false,
    keepPlacedBetsInLinearSingle: false,
    keepPlacedBetsInLinearCombo: false,
    keepPlacedBetsInLinearSystem: {},
    keepPlacedBetsInLinearBetBuilder: {},
    keepPlacedBetsInLinearTeaser: false,
};

export interface ISucceededSlipPickResultSaved extends Omit<ISucceededSlipPickResult, 'pickId' | 'clientPick'> {
    pickId: string;
    clientPick?: IBetslipPickStorage;
}

export interface ISucceededSlipResultSaved extends Omit<ISucceededSlipResult, 'picks'> {
    picks: ISucceededSlipPickResultSaved[];
}

export type ISucceededPartialSlipResultSaved = Omit<ISucceededPartialSlipResult, 'conclusionDate'>;

export interface IFailedSlipPickResultSaved extends Omit<IFailedSlipPickResult, 'clientPick' | 'errors'> {
    clientPick: IBetslipPickStorage;
    errors: ResultErrorSaved[];
}

export interface IFailedSlipResultSaved extends Omit<IFailedSlipResult, 'picks' | 'errors'> {
    picks: { [pickId: string]: IFailedSlipPickResultSaved };
    errors: BetPlacementErrorSaved[];
}

export interface IPlacedBetslipResultSaved {
    status: PlaceBetStatus;
    resultMessage: string;
    slips: (ISucceededSlipResultSaved | ISucceededPartialSlipResultSaved | IFailedSlipResultSaved)[];
}

export interface IBetslipResultStateSaved extends Omit<IBetslipResultState, 'result'> {
    result: IPlacedBetslipResultSaved;
    summary: Nullable<IBetslipResultSummaryViewModel>;
}
